import { render } from "./Interventi.vue?vue&type=template&id=fc870214&scoped=true&ts=true"
import script from "./Interventi.vue?vue&type=script&lang=ts"
export * from "./Interventi.vue?vue&type=script&lang=ts"

import "./Interventi.vue?vue&type=style&index=0&id=fc870214&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ambient/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc870214"]])

export default __exports__